// Extracted from lava .babylon file
// 3 mesh(es), 3 material(s), generated 2025-12-25
// Transforms are baked into vertex positions

import type { RuneMesh, RuneMaterials } from "./types.js";

export const LAVA_MATERIALS: RuneMaterials = [
  {
    name: "02___Default",
    albedoColor: [0.21570000, 0.21570000, 0.21570000],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
  {
    name: "01___Default",
    albedoColor: [0.42350000, 0.01570000, 0.01570000],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
  {
    name: "03___Default",
    albedoColor: [0.56080002, 0.20780000, 0.03530000],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
];

const LAVA_MESH_0: RuneMesh = {
  name: "Lava_Rune_primitive0",
  positions: new Float32Array([
    -0.79460001, 0.43309999, -0.00000003,
    -0.83679998, 0.42829999, -0.00000003,
    -0.81849998, 0.42829999, -0.17400002,
    -0.77719998, 0.43309999, -0.16520002,
    -0.72589999, 0.43309996, -0.32320002,
    -0.64289999, 0.43309996, -0.46710002,
    -0.53170002, 0.43309996, -0.59050006,
    -0.39730000, 0.43309993, -0.68820006,
    -0.24550000, 0.43309993, -0.75570005,
    -0.08310000, 0.43309993, -0.79030007,
    0.08310000, 0.43309993, -0.79030007,
    0.24550000, 0.43309993, -0.75570005,
    0.39730000, 0.43309993, -0.68820006,
    0.53170002, 0.43309996, -0.59050006,
    0.64279997, 0.43309996, -0.46710002,
    0.72589999, 0.43309996, -0.32320002,
    0.77719998, 0.43309999, -0.16520002,
    0.79460001, 0.43309999, -0.00000003,
    0.77719998, 0.43309999, 0.16519997,
    0.72589999, 0.43310001, 0.32319996,
    0.64279997, 0.43310001, 0.46709996,
    0.53119999, 0.43310001, 0.34729996,
    0.38859999, 0.43309999, -0.08070003,
    0.26289999, 0.43309996, -0.23700003,
    0.16440000, 0.43309996, -0.43400002,
    0.01490000, 0.43309996, -0.57660007,
    -0.11760000, 0.43309996, -0.38640004,
    -0.20590000, 0.43309999, -0.16900003,
    -0.39610001, 0.43309999, 0.02459997,
    -0.39950001, 0.43310001, 0.21819997,
    -0.49800000, 0.43310001, 0.44579998,
    0.33419999, 0.43310001, 0.30649996,
    0.53170002, 0.43310001, 0.59049994,
    0.39730000, 0.43310004, 0.68809992,
    0.24550000, 0.43310004, 0.75569993,
    0.08310000, 0.43310004, 0.79029995,
    -0.08310000, 0.43310004, 0.79019994,
    -0.24550000, 0.43310004, 0.75569993,
    -0.39730000, 0.43310004, 0.68809992,
    -0.53170002, 0.43310001, 0.59049994,
    -0.64289999, 0.43310001, 0.46709996,
    -0.72589999, 0.43310001, 0.32319996,
    -0.77719998, 0.43309999, 0.16519997,
    -0.81849998, 0.42829999, 0.17399997,
    -0.87690002, 0.41429999, -0.00000003,
    -0.85769999, 0.41429999, -0.18230003,
    -0.76450002, 0.42829996, -0.34040004,
    -0.67699999, 0.42829996, -0.49190003,
    -0.55989999, 0.42829993, -0.62190008,
    -0.41839999, 0.42829993, -0.72470003,
    -0.25860000, 0.42829993, -0.79590005,
    -0.08750000, 0.42829993, -0.83220005,
    0.08750000, 0.42829993, -0.83220005,
    0.25860000, 0.42829993, -0.79590005,
    0.41839999, 0.42829993, -0.72470003,
    0.55989999, 0.42829993, -0.62190008,
    0.67699999, 0.42829996, -0.49190003,
    0.76450002, 0.42829996, -0.34040004,
    0.81849998, 0.42829999, -0.17400002,
    0.83679998, 0.42829999, -0.00000003,
    0.81849998, 0.42829999, 0.17399997,
    0.76450002, 0.42830002, 0.34039998,
    0.67699999, 0.42830002, 0.49189997,
    0.55989999, 0.42830005, 0.62189996,
    0.41839999, 0.42830005, 0.72469991,
    0.25860000, 0.42830005, 0.79579991,
    0.08750000, 0.42830005, 0.83219993,
    -0.08750000, 0.42830005, 0.83219993,
    -0.25860000, 0.42830005, 0.79579991,
    -0.41839999, 0.42830005, 0.72469991,
    -0.55989999, 0.42830005, 0.62189996,
    -0.67699999, 0.42830002, 0.49189997,
    -0.76450002, 0.42830002, 0.34039998,
    -0.85769999, 0.41429999, 0.18229997,
    -0.91289997, 0.39170000, -0.00000003,
    -0.89289999, 0.39170000, -0.18980002,
    -0.80110002, 0.41429996, -0.35670003,
    -0.70940000, 0.41429996, -0.51540005,
    -0.58679998, 0.41429994, -0.65170008,
    -0.43840000, 0.41429994, -0.75940007,
    -0.27100000, 0.41429994, -0.83400005,
    -0.09170000, 0.41429994, -0.87210006,
    0.09170000, 0.41429994, -0.87210006,
    0.27100000, 0.41429994, -0.83400005,
    0.43840000, 0.41429994, -0.75940007,
    0.58679998, 0.41429994, -0.65170008,
    0.70940000, 0.41429996, -0.51540005,
    0.80110002, 0.41429996, -0.35670003,
    0.85769999, 0.41429999, -0.18230003,
    0.87690002, 0.41429999, -0.00000003,
    0.85769999, 0.41429999, 0.18229997,
    0.80110002, 0.41430002, 0.35669997,
    0.70940000, 0.41430002, 0.51539993,
    0.58679998, 0.41430005, 0.65169996,
    0.43840000, 0.41430005, 0.75939995,
    0.27100000, 0.41430005, 0.83399993,
    0.09170000, 0.41430005, 0.87209994,
    -0.09170000, 0.41430005, 0.87209994,
    -0.27100000, 0.41430005, 0.83399993,
    -0.43840000, 0.41430005, 0.75939995,
    -0.58679998, 0.41430005, 0.65169996,
    -0.70940000, 0.41430002, 0.51539993,
    -0.80110002, 0.41430002, 0.35669997,
    -0.89289999, 0.39170000, 0.18979996,
    -0.94290000, 0.36170000, -0.00000003,
    -0.92229998, 0.36170000, -0.19600002,
    -0.83389997, 0.39169997, -0.37130004,
    -0.73850000, 0.39169997, -0.53659999,
    -0.61080003, 0.39169994, -0.67839998,
    -0.45640001, 0.39169994, -0.79060000,
    -0.28209999, 0.39169994, -0.86820000,
    -0.09540000, 0.39169994, -0.90789998,
    0.09540000, 0.39169994, -0.90789998,
    0.28209999, 0.39169994, -0.86820000,
    0.45640001, 0.39169994, -0.79060000,
    0.61080003, 0.39169994, -0.67839998,
    0.73850000, 0.39169997, -0.53659999,
    0.83389997, 0.39169997, -0.37130004,
    0.89289999, 0.39170000, -0.18980002,
    0.91280001, 0.39170000, -0.00000003,
    0.89289999, 0.39170000, 0.18979996,
    0.83389997, 0.39170003, 0.37129998,
    0.73850000, 0.39170003, 0.53659999,
    0.61080003, 0.39170006, 0.67839998,
    0.45640001, 0.39170006, 0.79049999,
    0.28209999, 0.39170006, 0.86820000,
    0.09540000, 0.39170006, 0.90780002,
    -0.09540000, 0.39170006, 0.90780002,
    -0.28209999, 0.39170006, 0.86820000,
    -0.45640001, 0.39170006, 0.79049999,
    -0.61080003, 0.39170006, 0.67839998,
    -0.73850000, 0.39170003, 0.53659999,
    -0.83389997, 0.39170003, 0.37129998,
    -0.92229998, 0.36170000, 0.19599997,
    -0.96550000, 0.32570001, -0.00000002,
    -0.94440001, 0.32569999, -0.20070003,
    -0.86140001, 0.36169997, -0.38350004,
    -0.76279998, 0.36169997, -0.55419999,
    -0.63090003, 0.36169994, -0.70069999,
    -0.47139999, 0.36169994, -0.81660002,
    -0.29139999, 0.36169994, -0.89670002,
    -0.09860000, 0.36169994, -0.93769997,
    0.09860000, 0.36169994, -0.93769997,
    0.29139999, 0.36169994, -0.89670002,
    0.47139999, 0.36169994, -0.81660002,
    0.63090003, 0.36169994, -0.70069999,
    0.76279998, 0.36169997, -0.55419999,
    0.86140001, 0.36169997, -0.38350004,
    0.92229998, 0.36170000, -0.19600002,
    0.94290000, 0.36170000, -0.00000003,
    0.92229998, 0.36170000, 0.19599997,
    0.86140001, 0.36170003, 0.38349998,
    0.76279998, 0.36170003, 0.55419999,
    0.63090003, 0.36170006, 0.70069999,
    0.47139999, 0.36170006, 0.81660002,
    0.29139999, 0.36170006, 0.89670002,
    0.09860000, 0.36170006, 0.93769997,
    -0.09860000, 0.36170006, 0.93769997,
    -0.29139999, 0.36170006, 0.89670002,
    -0.47139999, 0.36170006, 0.81660002,
    -0.63090003, 0.36170006, 0.70069999,
    -0.76279998, 0.36170003, 0.55419999,
    -0.86140001, 0.36170003, 0.38349998,
    -0.94440001, 0.32570004, 0.20069997,
    -0.97950000, 0.28560001, -0.00000002,
    -0.95810002, 0.28559998, -0.20370002,
    -0.88200003, 0.32569999, -0.39270002,
    -0.78109998, 0.32569999, -0.56750000,
    -0.64600003, 0.32569996, -0.71749997,
    -0.48269999, 0.32569996, -0.83609998,
    -0.29830000, 0.32569996, -0.91820002,
    -0.10090000, 0.32569996, -0.96020001,
    0.10090000, 0.32569996, -0.96020001,
    0.29830000, 0.32569996, -0.91820002,
    0.48269999, 0.32569996, -0.83609998,
    0.64600003, 0.32569996, -0.71749997,
    0.78109998, 0.32569999, -0.56750000,
    0.88200003, 0.32569999, -0.39270002,
    0.94440001, 0.32569999, -0.20070003,
    0.96550000, 0.32570001, -0.00000002,
    0.94440001, 0.32570004, 0.20069997,
    0.88200003, 0.32570004, 0.39269996,
    0.78109998, 0.32570004, 0.56750000,
    0.64600003, 0.32570007, 0.71749997,
    0.48269999, 0.32570007, 0.83609998,
    0.29830000, 0.32570007, 0.91820002,
    0.10090000, 0.32570007, 0.96020001,
    -0.10090000, 0.32570007, 0.96020001,
    -0.29830000, 0.32570007, 0.91820002,
    -0.48269999, 0.32570007, 0.83609998,
    -0.64600003, 0.32570007, 0.71749997,
    -0.78109998, 0.32570004, 0.56750000,
    -0.88200003, 0.32570004, 0.39269996,
    -0.95810002, 0.28560004, 0.20359999,
    -0.98430002, 0.24339999, -0.00000002,
    -0.98430002, 0.24339999, -0.00000002,
    -0.98430002, 0.24339999, -0.00000002,
    -0.96270001, 0.24339998, -0.20460002,
    -0.96270001, 0.24339998, -0.20460002,
    -0.89480001, 0.28559998, -0.39840004,
    -0.79240000, 0.28559998, -0.57569999,
    -0.65539998, 0.28559995, -0.72790003,
    -0.48969999, 0.28559995, -0.84829998,
    -0.30270001, 0.28559995, -0.93159997,
    -0.10240000, 0.28559995, -0.97409999,
    0.10240000, 0.28559995, -0.97409999,
    0.30270001, 0.28559995, -0.93159997,
    0.48969999, 0.28559995, -0.84829998,
    0.65539998, 0.28559995, -0.72790003,
    0.79240000, 0.28559998, -0.57569999,
    0.89480001, 0.28559998, -0.39840004,
    0.95810002, 0.28559998, -0.20370002,
    0.97950000, 0.28560001, -0.00000002,
    0.95810002, 0.28560004, 0.20359999,
    0.89480001, 0.28560004, 0.39839998,
    0.79240000, 0.28560004, 0.57569999,
    0.65539998, 0.28560007, 0.72790003,
    0.48969999, 0.28560007, 0.84829998,
    0.30270001, 0.28560007, 0.93159997,
    0.10240000, 0.28560007, 0.97409999,
    -0.10240000, 0.28560007, 0.97409999,
    -0.30270001, 0.28560007, 0.93159997,
    -0.48980001, 0.28560007, 0.84829998,
    -0.65539998, 0.28560007, 0.72790003,
    -0.79240000, 0.28560004, 0.57569999,
    -0.89480001, 0.28560004, 0.39839998,
    -0.96270001, 0.24340001, 0.20459999,
    -0.96270001, 0.24340001, 0.20459999,
    -0.98430002, 0.21650000, -0.00000002,
    -0.98430002, 0.21650000, -0.00000002,
    -0.96270001, 0.21649998, -0.20460002,
    -0.89920002, 0.24339996, -0.40030003,
    -0.89920002, 0.24339996, -0.40030003,
    -0.79629999, 0.24339995, -0.57849997,
    -0.79629999, 0.24339995, -0.57849997,
    -0.65859997, 0.24339993, -0.73140001,
    -0.65859997, 0.24339993, -0.73140001,
    -0.49210000, 0.24339993, -0.85240000,
    -0.49210000, 0.24339993, -0.85240000,
    -0.30419999, 0.24339992, -0.93610001,
    -0.30419999, 0.24339992, -0.93610001,
    -0.10290000, 0.24339992, -0.97890002,
    -0.10290000, 0.24339992, -0.97890002,
    0.10290000, 0.24339992, -0.97890002,
    0.10290000, 0.24339992, -0.97890002,
    0.30410001, 0.24339992, -0.93610001,
    0.30410001, 0.24339992, -0.93610001,
    0.49210000, 0.24339993, -0.85240000,
    0.49210000, 0.24339993, -0.85240000,
    0.65859997, 0.24339993, -0.73140001,
    0.65859997, 0.24339993, -0.73140001,
    0.79629999, 0.24339995, -0.57849997,
    0.79629999, 0.24339995, -0.57849997,
    0.89920002, 0.24339996, -0.40030003,
    0.89920002, 0.24339996, -0.40030003,
    0.96270001, 0.24339998, -0.20460002,
    0.96270001, 0.24339998, -0.20460002,
    0.98430002, 0.24339999, -0.00000002,
    0.98430002, 0.24339999, -0.00000002,
    0.96270001, 0.24340001, 0.20459999,
    0.96270001, 0.24340001, 0.20459999,
    0.89920002, 0.24340002, 0.40029997,
    0.89920002, 0.24340002, 0.40029997,
    0.79629999, 0.24340004, 0.57849997,
    0.79629999, 0.24340004, 0.57849997,
    0.65859997, 0.24340005, 0.73140001,
    0.65859997, 0.24340005, 0.73140001,
    0.49210000, 0.24340005, 0.85240000,
    0.49210000, 0.24340005, 0.85240000,
    0.30410001, 0.24340007, 0.93610001,
    0.30410001, 0.24340007, 0.93610001,
    0.10290000, 0.24340007, 0.97890002,
    0.10290000, 0.24340007, 0.97890002,
    -0.10290000, 0.24340007, 0.97890002,
    -0.10290000, 0.24340007, 0.97890002,
    -0.30419999, 0.24340007, 0.93610001,
    -0.30419999, 0.24340007, 0.93610001,
    -0.49210000, 0.24340005, 0.85240000,
    -0.49210000, 0.24340005, 0.85240000,
    -0.65859997, 0.24340005, 0.73140001,
    -0.65859997, 0.24340005, 0.73140001,
    -0.79629999, 0.24340004, 0.57849997,
    -0.79629999, 0.24340004, 0.57849997,
    -0.89920002, 0.24340002, 0.40029997,
    -0.89920002, 0.24340002, 0.40029997,
    -0.96270001, 0.21650001, 0.20459999,
    -0.98430002, 0.18960001, -0.00000001,
    -0.98430002, 0.18960001, -0.00000001,
    -0.98430002, 0.18960001, -0.00000001,
    -0.96270001, 0.18959999, -0.20460002,
    -0.96270001, 0.18959999, -0.20460002,
    -0.89920002, 0.21649997, -0.40030003,
    -0.79629999, 0.21649995, -0.57849997,
    -0.65859997, 0.21649994, -0.73140001,
    -0.49210000, 0.21649994, -0.85240000,
    -0.30419999, 0.21649992, -0.93610001,
    -0.10290000, 0.21649992, -0.97890002,
    0.10290000, 0.21649992, -0.97890002,
    0.30410001, 0.21649992, -0.93610001,
    0.49210000, 0.21649994, -0.85240000,
    0.65859997, 0.21649994, -0.73140001,
    0.79629999, 0.21649995, -0.57849997,
    0.89920002, 0.21649997, -0.40030003,
    0.96270001, 0.21649998, -0.20460002,
    0.98430002, 0.21650000, -0.00000002,
    0.96270001, 0.21650001, 0.20459999,
    0.89920002, 0.21650003, 0.40029997,
    0.79629999, 0.21650004, 0.57849997,
    0.65859997, 0.21650006, 0.73140001,
    0.49210000, 0.21650006, 0.85240000,
    0.30410001, 0.21650007, 0.93610001,
    0.10290000, 0.21650007, 0.97890002,
    -0.10290000, 0.21650007, 0.97890002,
    -0.30419999, 0.21650007, 0.93610001,
    -0.49210000, 0.21650006, 0.85240000,
    -0.65859997, 0.21650006, 0.73140001,
    -0.79629999, 0.21650004, 0.57849997,
    -0.89920002, 0.21650003, 0.40029997,
    -0.96270001, 0.18960002, 0.20459999,
    -0.96270001, 0.18960002, 0.20459999,
    -0.97950000, 0.14740001, -0.00000001,
    -0.95810002, 0.14739999, -0.20370002,
    -0.89920002, 0.18959998, -0.40030000,
    -0.89920002, 0.18959998, -0.40030000,
    -0.79629999, 0.18959996, -0.57849997,
    -0.79629999, 0.18959996, -0.57849997,
    -0.65859997, 0.18959995, -0.73140001,
    -0.65859997, 0.18959995, -0.73140001,
    -0.49210000, 0.18959995, -0.85240000,
    -0.49210000, 0.18959995, -0.85240000,
    -0.30419999, 0.18959993, -0.93610001,
    -0.30419999, 0.18959993, -0.93610001,
    -0.10290000, 0.18959993, -0.97890002,
    -0.10290000, 0.18959993, -0.97890002,
    0.10290000, 0.18959993, -0.97890002,
    0.10290000, 0.18959993, -0.97890002,
    0.30410001, 0.18959993, -0.93610001,
    0.30410001, 0.18959993, -0.93610001,
    0.49210000, 0.18959995, -0.85240000,
    0.49210000, 0.18959995, -0.85240000,
    0.65859997, 0.18959995, -0.73140001,
    0.65859997, 0.18959995, -0.73140001,
    0.79629999, 0.18959996, -0.57849997,
    0.79629999, 0.18959996, -0.57849997,
    0.89920002, 0.18959998, -0.40030000,
    0.89920002, 0.18959998, -0.40030000,
    0.96270001, 0.18959999, -0.20460002,
    0.96270001, 0.18959999, -0.20460002,
    0.98430002, 0.18960001, -0.00000001,
    0.98430002, 0.18960001, -0.00000001,
    0.96270001, 0.18960002, 0.20459999,
    0.96270001, 0.18960002, 0.20459999,
    0.89920002, 0.18960004, 0.40030000,
    0.89920002, 0.18960004, 0.40030000,
    0.79629999, 0.18960005, 0.57849997,
    0.79629999, 0.18960005, 0.57849997,
    0.65859997, 0.18960007, 0.73140001,
    0.65859997, 0.18960007, 0.73140001,
    0.49210000, 0.18960007, 0.85240000,
    0.49210000, 0.18960007, 0.85240000,
    0.30410001, 0.18960008, 0.93610001,
    0.30410001, 0.18960008, 0.93610001,
    0.10290000, 0.18960008, 0.97890002,
    0.10290000, 0.18960008, 0.97890002,
    -0.10290000, 0.18960008, 0.97890002,
    -0.10290000, 0.18960008, 0.97890002,
    -0.30419999, 0.18960008, 0.93610001,
    -0.30419999, 0.18960008, 0.93610001,
    -0.49210000, 0.18960007, 0.85240000,
    -0.49210000, 0.18960007, 0.85240000,
    -0.65859997, 0.18960007, 0.73140001,
    -0.65859997, 0.18960007, 0.73140001,
    -0.79629999, 0.18960005, 0.57849997,
    -0.79629999, 0.18960005, 0.57849997,
    -0.89920002, 0.18960004, 0.40030000,
    -0.89920002, 0.18960004, 0.40030000,
    -0.95810002, 0.14740002, 0.20359999,
    -0.96550000, 0.10740000, -0.00000001,
    -0.94440001, 0.10739999, -0.20070001,
    -0.89480001, 0.14739998, -0.39840001,
    -0.79240000, 0.14739996, -0.57569999,
    -0.65539998, 0.14739995, -0.72790003,
    -0.48969999, 0.14739995, -0.84829998,
    -0.30270001, 0.14739993, -0.93159997,
    -0.10240000, 0.14739993, -0.97409999,
    0.10240000, 0.14739993, -0.97409999,
    0.30270001, 0.14739993, -0.93159997,
    0.48969999, 0.14739995, -0.84829998,
    0.65539998, 0.14739995, -0.72790003,
    0.79240000, 0.14739996, -0.57569999,
    0.89480001, 0.14739998, -0.39840001,
    0.95810002, 0.14739999, -0.20370002,
    0.97950000, 0.14740001, -0.00000001,
    0.95810002, 0.14740002, 0.20359999,
    0.89480001, 0.14740004, 0.39840001,
    0.79240000, 0.14740005, 0.57569999,
    0.65539998, 0.14740007, 0.72790003,
    0.48969999, 0.14740007, 0.84829998,
    0.30270001, 0.14740008, 0.93159997,
    0.10240000, 0.14740008, 0.97409999,
    -0.10240000, 0.14740008, 0.97409999,
    -0.30270001, 0.14740008, 0.93159997,
    -0.48980001, 0.14740007, 0.84829998,
    -0.65539998, 0.14740007, 0.72790003,
    -0.79240000, 0.14740005, 0.57569999,
    -0.89480001, 0.14740004, 0.39840001,
    -0.94440001, 0.10740001, 0.20069999,
    -0.94290000, 0.07140000, -0.00000001,
    -0.92229998, 0.07139999, -0.19599999,
    -0.88200003, 0.10739997, -0.39269999,
    -0.78109998, 0.10739996, -0.56750000,
    -0.64600003, 0.10739995, -0.71749997,
    -0.48269999, 0.10739994, -0.83609998,
    -0.29830000, 0.10739993, -0.91820002,
    -0.10090000, 0.10739993, -0.96020001,
    0.10090000, 0.10739993, -0.96020001,
    0.29830000, 0.10739993, -0.91820002,
    0.48269999, 0.10739994, -0.83609998,
    0.64600003, 0.10739995, -0.71749997,
    0.78109998, 0.10739996, -0.56750000,
    0.88200003, 0.10739997, -0.39269999,
    0.94440001, 0.10739999, -0.20070001,
    0.96550000, 0.10740000, -0.00000001,
    0.94440001, 0.10740001, 0.20069999,
    0.88200003, 0.10740003, 0.39269999,
    0.78109998, 0.10740004, 0.56750000,
    0.64600003, 0.10740005, 0.71749997,
    0.48269999, 0.10740006, 0.83609998,
    0.29830000, 0.10740007, 0.91820002,
    0.10090000, 0.10740007, 0.96020001,
    -0.10090000, 0.10740007, 0.96020001,
    -0.29830000, 0.10740007, 0.91820002,
    -0.48269999, 0.10740006, 0.83609998,
    -0.64600003, 0.10740005, 0.71749997,
    -0.78109998, 0.10740004, 0.56750000,
    -0.88200003, 0.10740003, 0.39269999,
    -0.92229998, 0.07140002, 0.19599999,
    -0.91289997, 0.04140000, -0.00000000,
    -0.89289999, 0.04139999, -0.18979999,
    -0.86140001, 0.07139997, -0.38350001,
    -0.76279998, 0.07139996, -0.55419999,
    -0.63090003, 0.07139995, -0.70069999,
    -0.47139999, 0.07139994, -0.81660002,
    -0.29139999, 0.07139993, -0.89670002,
    -0.09860000, 0.07139993, -0.93769997,
    0.09860000, 0.07139993, -0.93769997,
    0.29139999, 0.07139993, -0.89670002,
    0.47139999, 0.07139994, -0.81660002,
    0.63090003, 0.07139995, -0.70069999,
    0.76279998, 0.07139996, -0.55419999,
    0.86140001, 0.07139997, -0.38350001,
    0.92229998, 0.07139999, -0.19599999,
    0.94290000, 0.07140000, -0.00000001,
    0.92229998, 0.07140002, 0.19599999,
    0.86140001, 0.07140003, 0.38350001,
    0.76279998, 0.07140005, 0.55419999,
    0.63090003, 0.07140005, 0.70069999,
    0.47139999, 0.07140006, 0.81660002,
    0.29139999, 0.07140007, 0.89670002,
    0.09860000, 0.07140008, 0.93769997,
    -0.09860000, 0.07140008, 0.93769997,
    -0.29139999, 0.07140007, 0.89670002,
    -0.47139999, 0.07140006, 0.81660002,
    -0.63090003, 0.07140005, 0.70069999,
    -0.76279998, 0.07140005, 0.55419999,
    -0.86140001, 0.07140003, 0.38350001,
    -0.89289999, 0.04140002, 0.18979999,
    -0.87690002, 0.01880000, -0.00000000,
    -0.85769999, 0.01879999, -0.18230000,
    -0.83389997, 0.04139997, -0.37130001,
    -0.73850000, 0.04139996, -0.53659999,
    -0.61080003, 0.04139995, -0.67839998,
    -0.45640001, 0.04139994, -0.79060000,
    -0.28209999, 0.04139993, -0.86820000,
    -0.09540000, 0.04139993, -0.90789998,
    0.09540000, 0.04139993, -0.90789998,
    0.28209999, 0.04139993, -0.86820000,
    0.45640001, 0.04139994, -0.79060000,
    0.61080003, 0.04139995, -0.67839998,
    0.73850000, 0.04139996, -0.53659999,
    0.83389997, 0.04139997, -0.37130001,
    0.89289999, 0.04139999, -0.18979999,
    0.91280001, 0.04140000, -0.00000000,
    0.89289999, 0.04140002, 0.18979999,
    0.83389997, 0.04140003, 0.37130001,
    0.73850000, 0.04140004, 0.53659999,
    0.61080003, 0.04140005, 0.67839998,
    0.45640001, 0.04140006, 0.79049999,
    0.28209999, 0.04140007, 0.86820000,
    0.09540000, 0.04140007, 0.90780002,
    -0.09540000, 0.04140007, 0.90780002,
    -0.28209999, 0.04140007, 0.86820000,
    -0.45640001, 0.04140006, 0.79049999,
    -0.61080003, 0.04140005, 0.67839998,
    -0.73850000, 0.04140004, 0.53659999,
    -0.83389997, 0.04140003, 0.37130001,
    -0.85769999, 0.01880001, 0.18230000,
    -0.83679998, 0.00480000, -0.00000000,
    -0.81849998, 0.00479999, -0.17399999,
    -0.80110002, 0.01879997, -0.35670000,
    -0.70940000, 0.01879996, -0.51539999,
    -0.58679998, 0.01879995, -0.65170002,
    -0.43840000, 0.01879994, -0.75940001,
    -0.27100000, 0.01879994, -0.83399999,
    -0.09170000, 0.01879993, -0.87210000,
    0.09170000, 0.01879993, -0.87210000,
    0.27100000, 0.01879994, -0.83399999,
    0.43840000, 0.01879994, -0.75940001,
    0.58679998, 0.01879995, -0.65170002,
    0.70940000, 0.01879996, -0.51539999,
    0.80110002, 0.01879997, -0.35670000,
    0.85769999, 0.01879999, -0.18230000,
    0.87690002, 0.01880000, -0.00000000,
    0.85769999, 0.01880001, 0.18230000,
    0.80110002, 0.01880003, 0.35670000,
    0.70940000, 0.01880004, 0.51539999,
    0.58679998, 0.01880005, 0.65170002,
    0.43840000, 0.01880006, 0.75940001,
    0.27100000, 0.01880006, 0.83399999,
    0.09170000, 0.01880006, 0.87210000,
    -0.09170000, 0.01880006, 0.87210000,
    -0.27100000, 0.01880006, 0.83399999,
    -0.43840000, 0.01880006, 0.75940001,
    -0.58679998, 0.01880005, 0.65170002,
    -0.70940000, 0.01880004, 0.51539999,
    -0.80110002, 0.01880003, 0.35670000,
    -0.81849998, 0.00480001, 0.17399999,
    -0.79460001, 0.00000000, 0.00000000,
    -0.77719998, -0.00000001, -0.16520000,
    -0.76450002, 0.00479997, -0.34040001,
    -0.67699999, 0.00479996, -0.49190000,
    -0.55989999, 0.00479995, -0.62190002,
    -0.41839999, 0.00479995, -0.72469997,
    -0.25860000, 0.00479994, -0.79589999,
    -0.08750000, 0.00479994, -0.83219999,
    0.08750000, 0.00479994, -0.83219999,
    0.25860000, 0.00479994, -0.79589999,
    0.41839999, 0.00479995, -0.72469997,
    0.55989999, 0.00479995, -0.62190002,
    0.67699999, 0.00479996, -0.49190000,
    0.76450002, 0.00479997, -0.34040001,
    0.81849998, 0.00479999, -0.17399999,
    0.83679998, 0.00480000, -0.00000000,
    0.81849998, 0.00480001, 0.17399999,
    0.76450002, 0.00480003, 0.34040001,
    0.67699999, 0.00480004, 0.49190000,
    0.55989999, 0.00480005, 0.62190002,
    0.41839999, 0.00480005, 0.72469997,
    0.25860000, 0.00480006, 0.79579997,
    0.08750000, 0.00480006, 0.83219999,
    -0.08750000, 0.00480006, 0.83219999,
    -0.25860000, 0.00480006, 0.79579997,
    -0.41839999, 0.00480005, 0.72469997,
    -0.55989999, 0.00480005, 0.62190002,
    -0.67699999, 0.00480004, 0.49190000,
    -0.76450002, 0.00480003, 0.34040001,
    -0.77719998, 0.00000001, 0.16520000,
    0.00000000, 0.00000000, 0.00000000,
    -0.72589999, -0.00000002, -0.32319999,
    -0.64289999, -0.00000004, -0.46709999,
    -0.53170002, -0.00000004, -0.59050000,
    -0.39730000, -0.00000005, -0.68820000,
    -0.24550000, -0.00000006, -0.75569999,
    -0.08310000, -0.00000006, -0.79030001,
    0.08310000, -0.00000006, -0.79030001,
    0.24550000, -0.00000006, -0.75569999,
    0.39730000, -0.00000005, -0.68820000,
    0.53170002, -0.00000004, -0.59050000,
    0.64279997, -0.00000004, -0.46709999,
    0.72589999, -0.00000002, -0.32319999,
    0.77719998, -0.00000001, -0.16520000,
    0.79460001, 0.00000000, 0.00000000,
    0.77719998, 0.00000001, 0.16520000,
    0.72589999, 0.00000002, 0.32319999,
    0.64279997, 0.00000004, 0.46709999,
    0.53170002, 0.00000004, 0.59050000,
    0.39730000, 0.00000005, 0.68809998,
    0.24550000, 0.00000006, 0.75569999,
    0.08310000, 0.00000006, 0.79030001,
    -0.08310000, 0.00000006, 0.79020000,
    -0.24550000, 0.00000006, 0.75569999,
    -0.39730000, 0.00000005, 0.68809998,
    -0.53170002, 0.00000004, 0.59050000,
    -0.64289999, 0.00000004, 0.46709999,
    -0.72589999, 0.00000002, 0.32319999,
  ]),
  indices: new Uint16Array([
    0, 1, 2, 0, 2, 3, 42, 43, 1, 42, 1, 0,
    1, 44, 45, 1, 45, 2, 3, 2, 46, 3, 46, 4,
    4, 46, 47, 4, 47, 5, 5, 47, 48, 5, 48, 6,
    6, 48, 49, 6, 49, 7, 7, 49, 50, 7, 50, 8,
    8, 50, 51, 8, 51, 9, 9, 51, 52, 9, 52, 10,
    10, 52, 53, 10, 53, 11, 11, 53, 54, 11, 54, 12,
    12, 54, 55, 12, 55, 13, 13, 55, 56, 13, 56, 14,
    14, 56, 57, 14, 57, 15, 15, 57, 58, 15, 58, 16,
    16, 58, 59, 16, 59, 17, 17, 59, 60, 17, 60, 18,
    18, 60, 61, 18, 61, 19, 19, 61, 62, 19, 62, 20,
    20, 62, 63, 20, 63, 32, 32, 63, 64, 32, 64, 33,
    33, 64, 65, 33, 65, 34, 34, 65, 66, 34, 66, 35,
    35, 66, 67, 35, 67, 36, 36, 67, 68, 36, 68, 37,
    37, 68, 69, 37, 69, 38, 38, 69, 70, 38, 70, 39,
    39, 70, 71, 39, 71, 40, 40, 71, 72, 40, 72, 41,
    41, 72, 43, 41, 43, 42, 43, 73, 44, 43, 44, 1,
    44, 74, 75, 44, 75, 45, 2, 45, 76, 2, 76, 46,
    46, 76, 77, 46, 77, 47, 47, 77, 78, 47, 78, 48,
    48, 78, 79, 48, 79, 49, 49, 79, 80, 49, 80, 50,
    50, 80, 81, 50, 81, 51, 51, 81, 82, 51, 82, 52,
    52, 82, 83, 52, 83, 53, 53, 83, 84, 53, 84, 54,
    54, 84, 85, 54, 85, 55, 55, 85, 86, 55, 86, 56,
    56, 86, 87, 56, 87, 57, 57, 87, 88, 57, 88, 58,
    58, 88, 89, 58, 89, 59, 59, 89, 90, 59, 90, 60,
    60, 90, 91, 60, 91, 61, 61, 91, 92, 61, 92, 62,
    62, 92, 93, 62, 93, 63, 63, 93, 94, 63, 94, 64,
    64, 94, 95, 64, 95, 65, 65, 95, 96, 65, 96, 66,
    66, 96, 97, 66, 97, 67, 67, 97, 98, 67, 98, 68,
    68, 98, 99, 68, 99, 69, 69, 99, 100, 69, 100, 70,
    70, 100, 101, 70, 101, 71, 71, 101, 102, 71, 102, 72,
    72, 102, 73, 72, 73, 43, 73, 103, 74, 73, 74, 44,
    74, 104, 105, 74, 105, 75, 45, 75, 106, 45, 106, 76,
    76, 106, 107, 76, 107, 77, 77, 107, 108, 77, 108, 78,
    78, 108, 109, 78, 109, 79, 79, 109, 110, 79, 110, 80,
    80, 110, 111, 80, 111, 81, 81, 111, 112, 81, 112, 82,
    82, 112, 113, 82, 113, 83, 83, 113, 114, 83, 114, 84,
    84, 114, 115, 84, 115, 85, 85, 115, 116, 85, 116, 86,
    86, 116, 117, 86, 117, 87, 87, 117, 118, 87, 118, 88,
    88, 118, 119, 88, 119, 89, 89, 119, 120, 89, 120, 90,
    90, 120, 121, 90, 121, 91, 91, 121, 122, 91, 122, 92,
    92, 122, 123, 92, 123, 93, 93, 123, 124, 93, 124, 94,
    94, 124, 125, 94, 125, 95, 95, 125, 126, 95, 126, 96,
    96, 126, 127, 96, 127, 97, 97, 127, 128, 97, 128, 98,
    98, 128, 129, 98, 129, 99, 99, 129, 130, 99, 130, 100,
    100, 130, 131, 100, 131, 101, 101, 131, 132, 101, 132, 102,
    102, 132, 103, 102, 103, 73, 103, 133, 104, 103, 104, 74,
    104, 134, 135, 104, 135, 105, 75, 105, 136, 75, 136, 106,
    106, 136, 137, 106, 137, 107, 107, 137, 138, 107, 138, 108,
    108, 138, 139, 108, 139, 109, 109, 139, 140, 109, 140, 110,
    110, 140, 141, 110, 141, 111, 111, 141, 142, 111, 142, 112,
    112, 142, 143, 112, 143, 113, 113, 143, 144, 113, 144, 114,
    114, 144, 145, 114, 145, 115, 115, 145, 146, 115, 146, 116,
    116, 146, 147, 116, 147, 117, 117, 147, 148, 117, 148, 118,
    118, 148, 149, 118, 149, 119, 119, 149, 150, 119, 150, 120,
    120, 150, 151, 120, 151, 121, 121, 151, 152, 121, 152, 122,
    122, 152, 153, 122, 153, 123, 123, 153, 154, 123, 154, 124,
    124, 154, 155, 124, 155, 125, 125, 155, 156, 125, 156, 126,
    126, 156, 157, 126, 157, 127, 127, 157, 158, 127, 158, 128,
    128, 158, 159, 128, 159, 129, 129, 159, 160, 129, 160, 130,
    130, 160, 161, 130, 161, 131, 131, 161, 162, 131, 162, 132,
    132, 162, 133, 132, 133, 103, 133, 163, 134, 133, 134, 104,
    134, 164, 165, 134, 165, 135, 105, 135, 166, 105, 166, 136,
    136, 166, 167, 136, 167, 137, 137, 167, 168, 137, 168, 138,
    138, 168, 169, 138, 169, 139, 139, 169, 170, 139, 170, 140,
    140, 170, 171, 140, 171, 141, 141, 171, 172, 141, 172, 142,
    142, 172, 173, 142, 173, 143, 143, 173, 174, 143, 174, 144,
    144, 174, 175, 144, 175, 145, 145, 175, 176, 145, 176, 146,
    146, 176, 177, 146, 177, 147, 147, 177, 178, 147, 178, 148,
    148, 178, 179, 148, 179, 149, 149, 179, 180, 149, 180, 150,
    150, 180, 181, 150, 181, 151, 151, 181, 182, 151, 182, 152,
    152, 182, 183, 152, 183, 153, 153, 183, 184, 153, 184, 154,
    154, 184, 185, 154, 185, 155, 155, 185, 186, 155, 186, 156,
    156, 186, 187, 156, 187, 157, 157, 187, 188, 157, 188, 158,
    158, 188, 189, 158, 189, 159, 159, 189, 190, 159, 190, 160,
    160, 190, 191, 160, 191, 161, 161, 191, 192, 161, 192, 162,
    162, 192, 163, 162, 163, 133, 163, 193, 164, 163, 164, 134,
    164, 196, 198, 164, 198, 165, 135, 165, 199, 135, 199, 166,
    166, 199, 200, 166, 200, 167, 167, 200, 201, 167, 201, 168,
    168, 201, 202, 168, 202, 169, 169, 202, 203, 169, 203, 170,
    170, 203, 204, 170, 204, 171, 171, 204, 205, 171, 205, 172,
    172, 205, 206, 172, 206, 173, 173, 206, 207, 173, 207, 174,
    174, 207, 208, 174, 208, 175, 175, 208, 209, 175, 209, 176,
    176, 209, 210, 176, 210, 177, 177, 210, 211, 177, 211, 178,
    178, 211, 212, 178, 212, 179, 179, 212, 213, 179, 213, 180,
    180, 213, 214, 180, 214, 181, 181, 214, 215, 181, 215, 182,
    182, 215, 216, 182, 216, 183, 183, 216, 217, 183, 217, 184,
    184, 217, 218, 184, 218, 185, 185, 218, 219, 185, 219, 186,
    186, 219, 220, 186, 220, 187, 187, 220, 221, 187, 221, 188,
    188, 221, 222, 188, 222, 189, 189, 222, 223, 189, 223, 190,
    190, 223, 224, 190, 224, 191, 191, 224, 225, 191, 225, 192,
    192, 225, 193, 192, 193, 163, 193, 227, 196, 193, 196, 164,
    194, 228, 230, 194, 230, 197, 165, 198, 232, 165, 232, 199,
    199, 232, 234, 199, 234, 200, 200, 234, 236, 200, 236, 201,
    201, 236, 238, 201, 238, 202, 202, 238, 240, 202, 240, 203,
    203, 240, 242, 203, 242, 204, 204, 242, 244, 204, 244, 205,
    205, 244, 246, 205, 246, 206, 206, 246, 247, 206, 247, 207,
    207, 247, 249, 207, 249, 208, 208, 249, 251, 208, 251, 209,
    209, 251, 253, 209, 253, 210, 210, 253, 255, 210, 255, 211,
    211, 255, 257, 211, 257, 212, 212, 257, 259, 212, 259, 213,
    213, 259, 261, 213, 261, 214, 214, 261, 263, 214, 263, 215,
    215, 263, 265, 215, 265, 216, 216, 265, 267, 216, 267, 217,
    217, 267, 269, 217, 269, 218, 218, 269, 271, 218, 271, 219,
    219, 271, 273, 219, 273, 220, 220, 273, 275, 220, 275, 221,
    221, 275, 277, 221, 277, 222, 222, 277, 279, 222, 279, 223,
    223, 279, 282, 223, 282, 224, 224, 282, 284, 224, 284, 225,
    225, 284, 227, 225, 227, 193, 226, 285, 229, 226, 229, 195,
    228, 286, 289, 228, 289, 230, 197, 230, 291, 197, 291, 231,
    231, 291, 292, 231, 292, 233, 233, 292, 293, 233, 293, 235,
    235, 293, 294, 235, 294, 237, 237, 294, 295, 237, 295, 239,
    239, 295, 296, 239, 296, 241, 241, 296, 297, 241, 297, 243,
    243, 297, 298, 243, 298, 245, 245, 298, 299, 245, 299, 248,
    248, 299, 300, 248, 300, 250, 250, 300, 301, 250, 301, 252,
    252, 301, 302, 252, 302, 254, 254, 302, 303, 254, 303, 256,
    256, 303, 304, 256, 304, 258, 258, 304, 305, 258, 305, 260,
    260, 305, 306, 260, 306, 262, 262, 306, 307, 262, 307, 264,
    264, 307, 308, 264, 308, 266, 266, 308, 309, 266, 309, 268,
    268, 309, 310, 268, 310, 270, 270, 310, 311, 270, 311, 272,
    272, 311, 312, 272, 312, 274, 274, 312, 313, 274, 313, 276,
    276, 313, 314, 276, 314, 278, 278, 314, 315, 278, 315, 280,
    280, 315, 316, 280, 316, 281, 281, 316, 317, 281, 317, 283,
    283, 317, 285, 283, 285, 226, 285, 318, 288, 285, 288, 229,
    287, 320, 321, 287, 321, 290, 230, 289, 322, 230, 322, 291,
    291, 322, 324, 291, 324, 292, 292, 324, 326, 292, 326, 293,
    293, 326, 328, 293, 328, 294, 294, 328, 330, 294, 330, 295,
    295, 330, 332, 295, 332, 296, 296, 332, 334, 296, 334, 297,
    297, 334, 336, 297, 336, 298, 298, 336, 339, 298, 339, 299,
    299, 339, 341, 299, 341, 300, 300, 341, 343, 300, 343, 301,
    301, 343, 345, 301, 345, 302, 302, 345, 347, 302, 347, 303,
    303, 347, 349, 303, 349, 304, 304, 349, 351, 304, 351, 305,
    305, 351, 353, 305, 353, 306, 306, 353, 355, 306, 355, 307,
    307, 355, 357, 307, 357, 308, 308, 357, 359, 308, 359, 309,
    309, 359, 361, 309, 361, 310, 310, 361, 363, 310, 363, 311,
    311, 363, 365, 311, 365, 312, 312, 365, 367, 312, 367, 313,
    313, 367, 369, 313, 369, 314, 314, 369, 371, 314, 371, 315,
    315, 371, 372, 315, 372, 316, 316, 372, 374, 316, 374, 317,
    317, 374, 318, 317, 318, 285, 319, 376, 320, 319, 320, 287,
    320, 377, 378, 320, 378, 321, 290, 321, 379, 290, 379, 323,
    323, 379, 380, 323, 380, 325, 325, 380, 381, 325, 381, 327,
    327, 381, 382, 327, 382, 329, 329, 382, 383, 329, 383, 331,
    331, 383, 384, 331, 384, 333, 333, 384, 385, 333, 385, 335,
    335, 385, 386, 335, 386, 337, 337, 386, 387, 337, 387, 338,
    338, 387, 388, 338, 388, 340, 340, 388, 389, 340, 389, 342,
    342, 389, 390, 342, 390, 344, 344, 390, 391, 344, 391, 346,
    346, 391, 392, 346, 392, 348, 348, 392, 393, 348, 393, 350,
    350, 393, 394, 350, 394, 352, 352, 394, 395, 352, 395, 354,
    354, 395, 396, 354, 396, 356, 356, 396, 397, 356, 397, 358,
    358, 397, 398, 358, 398, 360, 360, 398, 399, 360, 399, 362,
    362, 399, 400, 362, 400, 364, 364, 400, 401, 364, 401, 366,
    366, 401, 402, 366, 402, 368, 368, 402, 403, 368, 403, 370,
    370, 403, 404, 370, 404, 373, 373, 404, 405, 373, 405, 375,
    375, 405, 376, 375, 376, 319, 376, 406, 377, 376, 377, 320,
    377, 407, 408, 377, 408, 378, 321, 378, 409, 321, 409, 379,
    379, 409, 410, 379, 410, 380, 380, 410, 411, 380, 411, 381,
    381, 411, 412, 381, 412, 382, 382, 412, 413, 382, 413, 383,
    383, 413, 414, 383, 414, 384, 384, 414, 415, 384, 415, 385,
    385, 415, 416, 385, 416, 386, 386, 416, 417, 386, 417, 387,
    387, 417, 418, 387, 418, 388, 388, 418, 419, 388, 419, 389,
    389, 419, 420, 389, 420, 390, 390, 420, 421, 390, 421, 391,
    391, 421, 422, 391, 422, 392, 392, 422, 423, 392, 423, 393,
    393, 423, 424, 393, 424, 394, 394, 424, 425, 394, 425, 395,
    395, 425, 426, 395, 426, 396, 396, 426, 427, 396, 427, 397,
    397, 427, 428, 397, 428, 398, 398, 428, 429, 398, 429, 399,
    399, 429, 430, 399, 430, 400, 400, 430, 431, 400, 431, 401,
    401, 431, 432, 401, 432, 402, 402, 432, 433, 402, 433, 403,
    403, 433, 434, 403, 434, 404, 404, 434, 435, 404, 435, 405,
    405, 435, 406, 405, 406, 376, 406, 436, 407, 406, 407, 377,
    407, 437, 438, 407, 438, 408, 378, 408, 439, 378, 439, 409,
    409, 439, 440, 409, 440, 410, 410, 440, 441, 410, 441, 411,
    411, 441, 442, 411, 442, 412, 412, 442, 443, 412, 443, 413,
    413, 443, 444, 413, 444, 414, 414, 444, 445, 414, 445, 415,
    415, 445, 446, 415, 446, 416, 416, 446, 447, 416, 447, 417,
    417, 447, 448, 417, 448, 418, 418, 448, 449, 418, 449, 419,
    419, 449, 450, 419, 450, 420, 420, 450, 451, 420, 451, 421,
    421, 451, 452, 421, 452, 422, 422, 452, 453, 422, 453, 423,
    423, 453, 454, 423, 454, 424, 424, 454, 455, 424, 455, 425,
    425, 455, 456, 425, 456, 426, 426, 456, 457, 426, 457, 427,
    427, 457, 458, 427, 458, 428, 428, 458, 459, 428, 459, 429,
    429, 459, 460, 429, 460, 430, 430, 460, 461, 430, 461, 431,
    431, 461, 462, 431, 462, 432, 432, 462, 463, 432, 463, 433,
    433, 463, 464, 433, 464, 434, 434, 464, 465, 434, 465, 435,
    435, 465, 436, 435, 436, 406, 436, 466, 437, 436, 437, 407,
    437, 467, 468, 437, 468, 438, 408, 438, 469, 408, 469, 439,
    439, 469, 470, 439, 470, 440, 440, 470, 471, 440, 471, 441,
    441, 471, 472, 441, 472, 442, 442, 472, 473, 442, 473, 443,
    443, 473, 474, 443, 474, 444, 444, 474, 475, 444, 475, 445,
    445, 475, 476, 445, 476, 446, 446, 476, 477, 446, 477, 447,
    447, 477, 478, 447, 478, 448, 448, 478, 479, 448, 479, 449,
    449, 479, 480, 449, 480, 450, 450, 480, 481, 450, 481, 451,
    451, 481, 482, 451, 482, 452, 452, 482, 483, 452, 483, 453,
    453, 483, 484, 453, 484, 454, 454, 484, 485, 454, 485, 455,
    455, 485, 486, 455, 486, 456, 456, 486, 487, 456, 487, 457,
    457, 487, 488, 457, 488, 458, 458, 488, 489, 458, 489, 459,
    459, 489, 490, 459, 490, 460, 460, 490, 491, 460, 491, 461,
    461, 491, 492, 461, 492, 462, 462, 492, 493, 462, 493, 463,
    463, 493, 494, 463, 494, 464, 464, 494, 495, 464, 495, 465,
    465, 495, 466, 465, 466, 436, 466, 496, 467, 466, 467, 437,
    467, 497, 498, 467, 498, 468, 438, 468, 499, 438, 499, 469,
    469, 499, 500, 469, 500, 470, 470, 500, 501, 470, 501, 471,
    471, 501, 502, 471, 502, 472, 472, 502, 503, 472, 503, 473,
    473, 503, 504, 473, 504, 474, 474, 504, 505, 474, 505, 475,
    475, 505, 506, 475, 506, 476, 476, 506, 507, 476, 507, 477,
    477, 507, 508, 477, 508, 478, 478, 508, 509, 478, 509, 479,
    479, 509, 510, 479, 510, 480, 480, 510, 511, 480, 511, 481,
    481, 511, 512, 481, 512, 482, 482, 512, 513, 482, 513, 483,
    483, 513, 514, 483, 514, 484, 484, 514, 515, 484, 515, 485,
    485, 515, 516, 485, 516, 486, 486, 516, 517, 486, 517, 487,
    487, 517, 518, 487, 518, 488, 488, 518, 519, 488, 519, 489,
    489, 519, 520, 489, 520, 490, 490, 520, 521, 490, 521, 491,
    491, 521, 522, 491, 522, 492, 492, 522, 523, 492, 523, 493,
    493, 523, 524, 493, 524, 494, 494, 524, 525, 494, 525, 495,
    495, 525, 496, 495, 496, 466, 496, 526, 497, 496, 497, 467,
    497, 527, 528, 497, 528, 498, 468, 498, 529, 468, 529, 499,
    499, 529, 530, 499, 530, 500, 500, 530, 531, 500, 531, 501,
    501, 531, 532, 501, 532, 502, 502, 532, 533, 502, 533, 503,
    503, 533, 534, 503, 534, 504, 504, 534, 535, 504, 535, 505,
    505, 535, 536, 505, 536, 506, 506, 536, 537, 506, 537, 507,
    507, 537, 538, 507, 538, 508, 508, 538, 539, 508, 539, 509,
    509, 539, 540, 509, 540, 510, 510, 540, 541, 510, 541, 511,
    511, 541, 542, 511, 542, 512, 512, 542, 543, 512, 543, 513,
    513, 543, 544, 513, 544, 514, 514, 544, 545, 514, 545, 515,
    515, 545, 546, 515, 546, 516, 516, 546, 547, 516, 547, 517,
    517, 547, 548, 517, 548, 518, 518, 548, 549, 518, 549, 519,
    519, 549, 550, 519, 550, 520, 520, 550, 551, 520, 551, 521,
    521, 551, 552, 521, 552, 522, 522, 552, 553, 522, 553, 523,
    523, 553, 554, 523, 554, 524, 524, 554, 555, 524, 555, 525,
    525, 555, 526, 525, 526, 496, 526, 556, 527, 526, 527, 497,
    527, 557, 528, 498, 528, 558, 498, 558, 529, 529, 558, 559,
    529, 559, 530, 530, 559, 560, 530, 560, 531, 531, 560, 561,
    531, 561, 532, 532, 561, 562, 532, 562, 533, 533, 562, 563,
    533, 563, 534, 534, 563, 564, 534, 564, 535, 535, 564, 565,
    535, 565, 536, 536, 565, 566, 536, 566, 537, 537, 566, 567,
    537, 567, 538, 538, 567, 568, 538, 568, 539, 539, 568, 569,
    539, 569, 540, 540, 569, 570, 540, 570, 541, 541, 570, 571,
    541, 571, 542, 542, 571, 572, 542, 572, 543, 543, 572, 573,
    543, 573, 544, 544, 573, 574, 544, 574, 545, 545, 574, 575,
    545, 575, 546, 546, 575, 576, 546, 576, 547, 547, 576, 577,
    547, 577, 548, 548, 577, 578, 548, 578, 549, 549, 578, 579,
    549, 579, 550, 550, 579, 580, 550, 580, 551, 551, 580, 581,
    551, 581, 552, 552, 581, 582, 552, 582, 553, 553, 582, 583,
    553, 583, 554, 554, 583, 584, 554, 584, 555, 555, 584, 556,
    555, 556, 526, 556, 557, 527, 528, 557, 558, 558, 557, 559,
    559, 557, 560, 560, 557, 561, 561, 557, 562, 562, 557, 563,
    563, 557, 564, 564, 557, 565, 565, 557, 566, 566, 557, 567,
    567, 557, 568, 568, 557, 569, 569, 557, 570, 570, 557, 571,
    571, 557, 572, 572, 557, 573, 573, 557, 574, 574, 557, 575,
    575, 557, 576, 576, 557, 577, 577, 557, 578, 578, 557, 579,
    579, 557, 580, 580, 557, 581, 581, 557, 582, 582, 557, 583,
    583, 557, 584, 584, 557, 556, 32, 33, 34, 34, 35, 36,
    36, 37, 31, 31, 21, 20, 20, 32, 34, 34, 36, 31,
    34, 31, 20, 37, 38, 39, 39, 40, 41, 41, 42, 0,
    0, 3, 4, 4, 5, 6, 6, 7, 8, 8, 9, 10,
    10, 11, 12, 12, 13, 14, 14, 15, 16, 16, 17, 18,
    18, 19, 20, 20, 21, 22, 22, 23, 24, 18, 20, 22,
    14, 16, 18, 10, 12, 14, 6, 8, 10, 0, 4, 6,
    39, 41, 0, 31, 37, 39, 28, 29, 30, 30, 31, 39,
    39, 0, 6, 10, 14, 18, 18, 22, 24, 10, 18, 24,
    30, 39, 6, 26, 27, 28, 28, 30, 6, 10, 24, 25,
    26, 28, 6, 10, 25, 26, 6, 10, 26,
  ]),
  normals: new Float32Array([
    -0.05980062, 0.99821034, 0.00000000,
    -0.22980847, 0.97323587, 0.00000000,
    -0.22471200, 0.97325199, -0.04780255,
    -0.05850061, 0.99821036, -0.01240013,
    -0.05460068, 0.99821253, -0.02430030,
    -0.04840054, 0.99821108, -0.03510039,
    -0.04000051, 0.99821268, -0.04440056,
    -0.02990029, 0.99820974, -0.05180051,
    -0.01850016, 0.99820844, -0.05690048,
    -0.00630005, 0.99820839, -0.05950050,
    0.00630005, 0.99820839, -0.05950050,
    0.01850016, 0.99820844, -0.05690048,
    0.02990029, 0.99820974, -0.05180051,
    0.04000051, 0.99821268, -0.04440056,
    0.04840054, 0.99821108, -0.03510039,
    0.05460068, 0.99821253, -0.02430030,
    0.05850061, 0.99821036, -0.01240013,
    0.05980062, 0.99821034, 0.00000000,
    0.05850061, 0.99821036, 0.01240013,
    0.05460068, 0.99821253, 0.02430030,
    0.05149858, 0.99797255, 0.03739897,
    -0.04190080, 0.99851900, -0.03470066,
    -0.86401498, -0.24360423, 0.44060764,
    -0.26049868, 0.95149515, 0.16369917,
    -0.75219161, -0.23479736, 0.61569309,
    0.07040256, -0.13430488, 0.98843598,
    0.82101978, -0.29260705, 0.49021182,
    0.31469052, 0.92677203, 0.20509381,
    0.92696761, -0.21829237, 0.30508932,
    0.31391144, 0.94423436, 0.09940362,
    0.76945219, -0.10720726, -0.62964270,
    0.04080035, 0.93370803, -0.35570303,
    0.04000051, 0.99821268, 0.04440056,
    0.02990029, 0.99820974, 0.05180051,
    0.01850016, 0.99820844, 0.05690048,
    0.00630005, 0.99820839, 0.05950050,
    -0.00630005, 0.99820839, 0.05950050,
    -0.01850016, 0.99820844, 0.05690048,
    -0.02990029, 0.99820974, 0.05180051,
    -0.04000051, 0.99821268, 0.04440056,
    -0.04840054, 0.99821108, 0.03510039,
    -0.05460068, 0.99821253, 0.02430030,
    -0.05850061, 0.99821036, 0.01240013,
    -0.22471200, 0.97325199, 0.04780255,
    -0.43951681, 0.89823436, 0.00000000,
    -0.42999631, 0.89819227, -0.09139921,
    -0.20969890, 0.97329487, -0.09339951,
    -0.18590659, 0.97323452, -0.13510480,
    -0.15350420, 0.97332658, -0.17050465,
    -0.11470283, 0.97332401, -0.19870490,
    -0.07100194, 0.97322667, -0.21860598,
    -0.02400098, 0.97333966, -0.22810930,
    0.02400098, 0.97333966, -0.22810930,
    0.07100194, 0.97322667, -0.21860598,
    0.11469394, 0.97334861, -0.19858950,
    0.15369423, 0.97326347, -0.17069359,
    0.18590659, 0.97323452, -0.13510480,
    0.20960329, 0.97331528, -0.09340147,
    0.22471200, 0.97325199, -0.04780255,
    0.22980847, 0.97323587, 0.00000000,
    0.22471200, 0.97325199, 0.04780255,
    0.20950964, 0.97334476, 0.09330429,
    0.18590659, 0.97323452, 0.13510480,
    0.15369423, 0.97326347, 0.17069359,
    0.11480380, 0.97333217, 0.19860657,
    0.07099814, 0.97327447, 0.21839428,
    0.02399934, 0.97327301, 0.22839368,
    -0.02399988, 0.97329524, 0.22829889,
    -0.07099969, 0.97329573, 0.21829904,
    -0.11480380, 0.97333217, 0.19860657,
    -0.15369423, 0.97326347, 0.17069359,
    -0.18590659, 0.97323452, 0.13510480,
    -0.20950767, 0.97333567, 0.09340342,
    -0.43007782, 0.89815365, 0.09139528,
    -0.62772702, 0.77843355, 0.00000000,
    -0.61396481, 0.77845540, -0.13059251,
    -0.40179357, 0.89808560, -0.17889713,
    -0.35598830, 0.89797051, -0.25869151,
    -0.29420948, 0.89812898, -0.32681054,
    -0.22000385, 0.89801571, -0.38100668,
    -0.13590467, 0.89803082, -0.41841435,
    -0.04599958, 0.89809176, -0.43739597,
    0.04600148, 0.89822890, -0.43711407,
    0.13590467, 0.89803082, -0.41841435,
    0.22000385, 0.89801571, -0.38100668,
    0.29420948, 0.89812898, -0.32681054,
    0.35580008, 0.89810023, -0.25850006,
    0.40179357, 0.89808560, -0.17889713,
    0.43019793, 0.89809568, -0.09139956,
    0.43979830, 0.89809657, 0.00000000,
    0.43019793, 0.89809568, 0.09139956,
    0.40179357, 0.89808560, 0.17889713,
    0.35598830, 0.89797051, 0.25869151,
    0.29429121, 0.89807319, 0.32689024,
    0.21989731, 0.89808903, 0.38089534,
    0.13590383, 0.89812531, 0.41821177,
    0.04599958, 0.89809176, 0.43739597,
    -0.04599958, 0.89809176, 0.43739597,
    -0.13590383, 0.89812531, 0.41821177,
    -0.21989731, 0.89808903, 0.38089534,
    -0.29429121, 0.89807319, 0.32689024,
    -0.35580008, 0.89810023, 0.25850006,
    -0.40179357, 0.89808560, 0.17889713,
    -0.61423280, 0.77824154, 0.13060698,
    -0.78468818, 0.61989069, 0.00000000,
    -0.76752538, 0.61992050, -0.16310540,
    -0.57343668, 0.77844972, -0.25531629,
    -0.50798741, 0.77828063, -0.36909084,
    -0.42017314, 0.77825028, -0.46667016,
    -0.31398975, 0.77827458, -0.54378223,
    -0.19409639, 0.77818545, -0.59728888,
    -0.06560022, 0.77810270, -0.62470216,
    0.06560022, 0.77810270, -0.62470216,
    0.19409639, 0.77818545, -0.59728888,
    0.31398975, 0.77827458, -0.54378223,
    0.42017314, 0.77825028, -0.46667016,
    0.50798741, 0.77828063, -0.36909084,
    0.57343668, 0.77844972, -0.25531629,
    0.61391052, 0.77851335, -0.13050224,
    0.62761756, 0.77852180, 0.00000000,
    0.61391052, 0.77851335, 0.13050224,
    0.57343668, 0.77844972, 0.25531629,
    0.50798741, 0.77828063, 0.36909084,
    0.42009080, 0.77828296, 0.46668977,
    0.31389223, 0.77838077, 0.54368654,
    0.19399664, 0.77828648, 0.59718964,
    0.06550375, 0.77824445, 0.62453569,
    -0.06550375, 0.77824445, 0.62453569,
    -0.19399664, 0.77828648, 0.59718964,
    -0.31389223, 0.77838077, 0.54368654,
    -0.42009080, 0.77828296, 0.46668977,
    -0.50798741, 0.77828063, 0.36909084,
    -0.57343668, 0.77844972, 0.25531629,
    -0.76752538, 0.61992050, 0.16310540,
    -0.90236087, 0.43098128, 0.00000000,
    -0.88288393, 0.43049215, -0.18759658,
    -0.71683475, 0.61993005, -0.31911547,
    -0.63481510, 0.61991472, -0.46121094,
    -0.52517318, 0.61966842, -0.58327025,
    -0.39229617, 0.61999393, -0.67949337,
    -0.24250947, 0.61982417, -0.74632912,
    -0.08190100, 0.62000751, -0.78030950,
    0.08199901, 0.61989253, -0.78039055,
    0.24250947, 0.61982417, -0.74632912,
    0.39229384, 0.61989022, -0.67958933,
    0.52517318, 0.61966842, -0.58327025,
    0.63481510, 0.61991472, -0.46121094,
    0.71683475, 0.61993005, -0.31911547,
    0.76738911, 0.62009120, -0.16309769,
    0.78477526, 0.61978044, 0.00000000,
    0.76738911, 0.62009120, 0.16309769,
    0.71683475, 0.61993005, 0.31911547,
    0.63481510, 0.61991472, 0.46121094,
    0.52512562, 0.62003028, 0.58292841,
    0.39229617, 0.61999393, 0.67949337,
    0.24258547, 0.61976287, 0.74635532,
    0.08210096, 0.62010733, 0.78020916,
    -0.08210096, 0.62010733, 0.78020916,
    -0.24258547, 0.61976287, 0.74635532,
    -0.39229617, 0.61999393, 0.67949337,
    -0.52509887, 0.61979868, 0.58319874,
    -0.63481510, 0.61991472, 0.46121094,
    -0.71683475, 0.61993005, 0.31911547,
    -0.88268771, 0.43089400, 0.18759738,
    -0.97529663, 0.22089924, 0.00000000,
    -0.95400508, 0.22060116, -0.20300107,
    -0.82437009, 0.43088436, -0.36708668,
    -0.73021001, 0.43040592, -0.53060728,
    -0.60376194, 0.43107287, -0.67055776,
    -0.45111705, 0.43111632, -0.78142954,
    -0.27880033, 0.43100049, -0.85820100,
    -0.09430093, 0.43100424, -0.89740887,
    0.09429620, 0.43068263, -0.89756376,
    0.27880033, 0.43100049, -0.85820100,
    0.45129943, 0.43079946, -0.78149898,
    0.60378798, 0.43099142, -0.67058666,
    0.73007632, 0.43078602, -0.53048277,
    0.82437009, 0.43088436, -0.36708668,
    0.88288393, 0.43049215, -0.18759658,
    0.90230338, 0.43110161, 0.00000000,
    0.88262757, 0.43101348, 0.18760586,
    0.82433277, 0.43101713, 0.36701461,
    0.73021001, 0.43040592, 0.53060728,
    0.60376194, 0.43107287, 0.67055776,
    0.45111705, 0.43111632, 0.78142954,
    0.27880033, 0.43100049, 0.85820100,
    0.09430093, 0.43100424, 0.89740887,
    -0.09429620, 0.43068263, 0.89756376,
    -0.27869606, 0.43109396, 0.85818792,
    -0.45111705, 0.43111632, 0.78142954,
    -0.60380243, 0.43110176, 0.67050271,
    -0.73007632, 0.43078602, 0.53048277,
    -0.82433277, 0.43101713, 0.36701461,
    -0.95404379, 0.22061011, 0.20280932,
    -0.99844184, 0.05580234, 0.00000000,
    -0.99844184, 0.05580234, 0.00000000,
    -0.99844184, 0.05580234, 0.00000000,
    -0.97662549, 0.05570145, -0.20760542,
    -0.97662549, 0.05570145, -0.20760542,
    -0.89097426, 0.22109362, -0.39658855,
    -0.78902109, 0.22080592, -0.57331533,
    -0.65260832, 0.22080282, -0.72480928,
    -0.48759211, 0.22119642, -0.84458633,
    -0.30139453, 0.22079598, -0.92758314,
    -0.10189677, 0.22129300, -0.96986930,
    0.10189903, 0.22119788, -0.96989076,
    0.30138787, 0.22089110, -0.92756265,
    0.48760288, 0.22110131, -0.84460502,
    0.65250764, 0.22110260, -0.72480854,
    0.78902109, 0.22080592, -0.57331533,
    0.89097426, 0.22109362, -0.39658855,
    0.95400508, 0.22060116, -0.20300107,
    0.97529663, 0.22089924, 0.00000000,
    0.95404379, 0.22061011, 0.20280932,
    0.89097426, 0.22109362, 0.39658855,
    0.78902109, 0.22080592, 0.57331533,
    0.65260832, 0.22080282, 0.72480928,
    0.48760288, 0.22110131, 0.84460502,
    0.30138787, 0.22089110, 0.92756265,
    0.10189903, 0.22119788, 0.96989076,
    -0.10189677, 0.22129300, 0.96986930,
    -0.30140915, 0.22100672, 0.92752820,
    -0.48779650, 0.22109842, 0.84449397,
    -0.65238854, 0.22119611, 0.72488722,
    -0.78902109, 0.22080592, 0.57331533,
    -0.89097426, 0.22109362, 0.39658855,
    -0.97662004, 0.05580114, 0.20760425,
    -0.97662004, 0.05580114, 0.20760425,
    -1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -0.97814792, 0.00000000, -0.20791019,
    -0.91216314, 0.05599774, -0.40598357,
    -0.91216314, 0.05599774, -0.40598357,
    -0.80775714, 0.05579704, -0.58686889,
    -0.80775714, 0.05579704, -0.58686889,
    -0.66813405, 0.05590285, -0.74193784,
    -0.66813405, 0.05590285, -0.74193784,
    -0.49938821, 0.05579868, -0.86457962,
    -0.49938821, 0.05579868, -0.86457962,
    -0.30861232, 0.05600223, -0.94953788,
    -0.30861232, 0.05600223, -0.94953788,
    -0.10439501, 0.05609732, -0.99295255,
    -0.10439501, 0.05609732, -0.99295255,
    0.10439560, 0.05599764, -0.99295812,
    0.10439560, 0.05599764, -0.99295812,
    0.30849597, 0.05579927, -0.94958764,
    0.30849597, 0.05579927, -0.94958764,
    0.49918934, 0.05599880, -0.86468152,
    0.49918934, 0.05599880, -0.86468152,
    0.66813405, 0.05590285, -0.74193784,
    0.66813405, 0.05590285, -0.74193784,
    0.80780907, 0.05570062, -0.58680656,
    0.80780907, 0.05570062, -0.58680656,
    0.91216314, 0.05599774, -0.40598357,
    0.91216314, 0.05599774, -0.40598357,
    0.97662549, 0.05570145, -0.20760542,
    0.97662549, 0.05570145, -0.20760542,
    0.99844184, 0.05580234, 0.00000000,
    0.99844184, 0.05580234, 0.00000000,
    0.97662004, 0.05580114, 0.20760425,
    0.97662004, 0.05580114, 0.20760425,
    0.91205048, 0.05569697, 0.40627795,
    0.91205048, 0.05569697, 0.40627795,
    0.80775714, 0.05579704, 0.58686889,
    0.80775714, 0.05579704, 0.58686889,
    0.66813405, 0.05590285, 0.74193784,
    0.66813405, 0.05590285, 0.74193784,
    0.49931595, 0.05570178, 0.86462760,
    0.49931595, 0.05570178, 0.86462760,
    0.30849597, 0.05579927, 0.94958764,
    0.30849597, 0.05579927, 0.94958764,
    0.10439560, 0.05599764, 0.99295812,
    0.10439560, 0.05599764, 0.99295812,
    -0.10439501, 0.05609732, 0.99295255,
    -0.10439501, 0.05609732, 0.99295255,
    -0.30861403, 0.05590254, 0.94954320,
    -0.30861403, 0.05590254, 0.94954320,
    -0.49932150, 0.05550239, 0.86463722,
    -0.49932150, 0.05550239, 0.86463722,
    -0.66819688, 0.05569974, 0.74189653,
    -0.66819688, 0.05569974, 0.74189653,
    -0.80780907, 0.05570062, 0.58680656,
    -0.80780907, 0.05570062, 0.58680656,
    -0.91215802, 0.05609742, 0.40598131,
    -0.91215802, 0.05609742, 0.40598131,
    -0.97814792, 0.00000000, 0.20791019,
    -0.99844184, -0.05580234, 0.00000000,
    -0.99844184, -0.05580234, 0.00000000,
    -0.99844184, -0.05580234, 0.00000000,
    -0.97662549, -0.05570145, -0.20760542,
    -0.97662549, -0.05570145, -0.20760542,
    -0.91360525, 0.00000000, -0.40660231,
    -0.80895657, 0.00000000, -0.58786841,
    -0.66913599, 0.00000000, -0.74313998,
    -0.50012935, 0.00000000, -0.86595071,
    -0.30910870, 0.00000000, -0.95102672,
    -0.10460149, 0.00000000, -0.99451422,
    0.10460149, 0.00000000, -0.99451422,
    0.30910870, 0.00000000, -0.95102672,
    0.50001101, 0.00000000, -0.86601905,
    0.66913599, 0.00000000, -0.74313998,
    0.80895657, 0.00000000, -0.58786841,
    0.91360525, 0.00000000, -0.40660231,
    0.97814792, 0.00000000, -0.20791019,
    1.00000000, 0.00000000, 0.00000000,
    0.97814792, 0.00000000, 0.20791019,
    0.91360525, 0.00000000, 0.40660231,
    0.80895657, 0.00000000, 0.58786841,
    0.66913599, 0.00000000, 0.74313998,
    0.50001101, 0.00000000, 0.86601905,
    0.30910870, 0.00000000, 0.95102672,
    0.10460149, 0.00000000, 0.99451422,
    -0.10460149, 0.00000000, 0.99451422,
    -0.30910870, 0.00000000, 0.95102672,
    -0.50012935, 0.00000000, 0.86595071,
    -0.66913599, 0.00000000, 0.74313998,
    -0.80895657, 0.00000000, 0.58786841,
    -0.91360525, 0.00000000, 0.40660231,
    -0.97662004, -0.05580114, 0.20760425,
    -0.97662004, -0.05580114, 0.20760425,
    -0.97527509, -0.22099435, 0.00000000,
    -0.95393118, -0.22100722, -0.20290665,
    -0.91216314, -0.05599774, -0.40598357,
    -0.91216314, -0.05599774, -0.40598357,
    -0.80780907, -0.05570062, -0.58680656,
    -0.80780907, -0.05570062, -0.58680656,
    -0.66813405, -0.05590285, -0.74193784,
    -0.66813405, -0.05590285, -0.74193784,
    -0.49938821, -0.05579868, -0.86457962,
    -0.49938821, -0.05579868, -0.86457962,
    -0.30861232, -0.05600223, -0.94953788,
    -0.30861232, -0.05600223, -0.94953788,
    -0.10439501, -0.05609732, -0.99295255,
    -0.10439501, -0.05609732, -0.99295255,
    0.10439560, -0.05599764, -0.99295812,
    0.10439560, -0.05599764, -0.99295812,
    0.30849597, -0.05579927, -0.94958764,
    0.30849597, -0.05579927, -0.94958764,
    0.49918934, -0.05599880, -0.86468152,
    0.49918934, -0.05599880, -0.86468152,
    0.66813405, -0.05590285, -0.74193784,
    0.66813405, -0.05590285, -0.74193784,
    0.80780907, -0.05570062, -0.58680656,
    0.80780907, -0.05570062, -0.58680656,
    0.91216314, -0.05599774, -0.40598357,
    0.91216314, -0.05599774, -0.40598357,
    0.97662549, -0.05570145, -0.20760542,
    0.97662549, -0.05570145, -0.20760542,
    0.99844184, -0.05580234, 0.00000000,
    0.99844184, -0.05580234, 0.00000000,
    0.97662004, -0.05580114, 0.20760425,
    0.97662004, -0.05580114, 0.20760425,
    0.91208245, -0.05579893, 0.40619217,
    0.91208245, -0.05579893, 0.40619217,
    0.80780907, -0.05570062, 0.58680656,
    0.80780907, -0.05570062, 0.58680656,
    0.66813405, -0.05590285, 0.74193784,
    0.66813405, -0.05590285, 0.74193784,
    0.49931595, -0.05570178, 0.86462760,
    0.49931595, -0.05570178, 0.86462760,
    0.30849597, -0.05579927, 0.94958764,
    0.30849597, -0.05579927, 0.94958764,
    0.10439560, -0.05599764, 0.99295812,
    0.10439560, -0.05599764, 0.99295812,
    -0.10439501, -0.05609732, 0.99295255,
    -0.10439501, -0.05609732, 0.99295255,
    -0.30861403, -0.05590254, 0.94954320,
    -0.30861403, -0.05590254, 0.94954320,
    -0.49918934, -0.05599880, 0.86468152,
    -0.49918934, -0.05599880, 0.86468152,
    -0.66819688, -0.05569974, 0.74189653,
    -0.66819688, -0.05569974, 0.74189653,
    -0.80780907, -0.05570062, 0.58680656,
    -0.80780907, -0.05570062, 0.58680656,
    -0.91208245, -0.05579893, 0.40619217,
    -0.91208245, -0.05579893, 0.40619217,
    -0.95395953, -0.22099063, 0.20279139,
    -0.90239973, -0.43089990, 0.00000000,
    -0.88268771, -0.43089400, -0.18759738,
    -0.89091830, -0.22110454, -0.39670815,
    -0.78902109, -0.22080592, -0.57331533,
    -0.65259796, -0.22119932, -0.72469771,
    -0.48761365, -0.22100619, -0.84462370,
    -0.30138787, -0.22089110, -0.92756265,
    -0.10190352, -0.22100767, -0.96993365,
    0.10190352, -0.22100767, -0.96993365,
    0.30139453, -0.22079598, -0.92758314,
    0.48760288, -0.22110131, -0.84460502,
    0.65259796, -0.22119932, -0.72469771,
    0.78895134, -0.22118637, -0.57326466,
    0.89099798, -0.22079950, -0.39669909,
    0.95393118, -0.22100722, -0.20290665,
    0.97527509, -0.22099435, 0.00000000,
    0.95395953, -0.22099063, 0.20279139,
    0.89101765, -0.22070437, 0.39670785,
    0.78902109, -0.22080592, 0.57331533,
    0.65259796, -0.22119932, 0.72469771,
    0.48762444, -0.22091107, 0.84464235,
    0.30139453, -0.22079598, 0.92758314,
    0.10189815, -0.22079600, 0.96998242,
    -0.10190352, -0.22100767, 0.96993365,
    -0.30139453, -0.22079598, 0.92758314,
    -0.48761365, -0.22100619, 0.84462370,
    -0.65257545, -0.22069170, 0.72487272,
    -0.78895134, -0.22118637, 0.57326466,
    -0.89101765, -0.22070437, 0.39670785,
    -0.88270918, -0.43080445, 0.18770195,
    -0.78468818, -0.61989069, 0.00000000,
    -0.76752538, -0.61992050, -0.16310540,
    -0.82440561, -0.43080291, -0.36710250,
    -0.73010776, -0.43070458, -0.53050564,
    -0.60379085, -0.43129347, -0.67038986,
    -0.45117726, -0.43117823, -0.78136061,
    -0.27869596, -0.43129376, -0.85808756,
    -0.09429687, -0.43108568, -0.89737018,
    0.09429687, -0.43108568, -0.89737018,
    0.27869596, -0.43129376, -0.85808756,
    0.45121980, -0.43081888, -0.78153425,
    0.60377641, -0.43118315, -0.67047382,
    0.73010776, -0.43070458, -0.53050564,
    0.82440561, -0.43080291, -0.36710250,
    0.88268771, -0.43089400, -0.18759738,
    0.90226449, -0.43118302, 0.00000000,
    0.88270918, -0.43080445, 0.18770195,
    0.82447315, -0.43068597, 0.36708803,
    0.73010776, -0.43070458, 0.53050564,
    0.60379085, -0.43129347, 0.67038986,
    0.45117726, -0.43117823, 0.78136061,
    0.27869596, -0.43129376, 0.85808756,
    0.09429687, -0.43108568, 0.89737018,
    -0.09429687, -0.43108568, 0.89737018,
    -0.27878830, -0.43108192, 0.85816401,
    -0.45111705, -0.43111632, 0.78142954,
    -0.60378798, -0.43099142, 0.67058666,
    -0.73010776, -0.43070458, 0.53050564,
    -0.82433277, -0.43101713, 0.36701461,
    -0.76752538, -0.61992050, 0.16310540,
    -0.62772702, -0.77843355, 0.00000000,
    -0.61423280, -0.77824154, -0.13060698,
    -0.71683475, -0.61993005, -0.31911547,
    -0.63481510, -0.61991472, -0.46121094,
    -0.52509499, -0.61999411, -0.58299447,
    -0.39229617, -0.61999393, -0.67949337,
    -0.24260050, -0.61970132, -0.74640155,
    -0.08190100, -0.62000751, -0.78030950,
    0.08220010, -0.61960083, -0.78060102,
    0.24260050, -0.61970132, -0.74640155,
    0.39231817, -0.61982866, -0.67963143,
    0.52517318, -0.61966842, -0.58327025,
    0.63481510, -0.61991472, -0.46121094,
    0.71683475, -0.61993005, -0.31911547,
    0.76738911, -0.62009120, -0.16309769,
    0.78468818, -0.61989069, 0.00000000,
    0.76738911, -0.62009120, 0.16309769,
    0.71683475, -0.61993005, 0.31911547,
    0.63481510, -0.61991472, 0.46121094,
    0.52519610, -0.62009539, 0.58279564,
    0.39229617, -0.61999393, 0.67949337,
    0.24258547, -0.61976287, 0.74635532,
    0.08210096, -0.62010733, 0.78020916,
    -0.08210096, -0.62010733, 0.78020916,
    -0.24258547, -0.61976287, 0.74635532,
    -0.39229850, -0.62009760, 0.67939742,
    -0.52509887, -0.61979868, 0.58319874,
    -0.63481510, -0.61991472, 0.46121094,
    -0.71683475, -0.61993005, 0.31911547,
    -0.61423280, -0.77824154, 0.13060698,
    -0.43951681, -0.89823436, 0.00000000,
    -0.42999631, -0.89819227, -0.09139921,
    -0.57371263, -0.77821706, -0.25540560,
    -0.50798741, -0.77828063, -0.36909084,
    -0.42017314, -0.77825028, -0.46667016,
    -0.31398975, -0.77827458, -0.54378223,
    -0.19409639, -0.77818545, -0.59728888,
    -0.06560022, -0.77810270, -0.62470216,
    0.06560022, -0.77810270, -0.62470216,
    0.19409639, -0.77818545, -0.59728888,
    0.31398975, -0.77827458, -0.54378223,
    0.42017314, -0.77825028, -0.46667016,
    0.50798741, -0.77828063, -0.36909084,
    0.57371263, -0.77821706, -0.25540560,
    0.61391052, -0.77851335, -0.13050224,
    0.62761756, -0.77852180, 0.00000000,
    0.61391052, -0.77851335, 0.13050224,
    0.57371263, -0.77821706, 0.25540560,
    0.50798741, -0.77828063, 0.36909084,
    0.42009080, -0.77828296, 0.46668977,
    0.31389223, -0.77838077, 0.54368654,
    0.19399664, -0.77828648, 0.59718964,
    0.06550375, -0.77824445, 0.62453569,
    -0.06550375, -0.77824445, 0.62453569,
    -0.19399664, -0.77828648, 0.59718964,
    -0.31389223, -0.77838077, 0.54368654,
    -0.42009080, -0.77828296, 0.46668977,
    -0.50798741, -0.77828063, 0.36909084,
    -0.57371263, -0.77821706, 0.25540560,
    -0.42999631, -0.89819227, 0.09139921,
    -0.22980847, -0.97323587, 0.00000000,
    -0.22471200, -0.97325199, -0.04780255,
    -0.40179357, -0.89808560, -0.17889713,
    -0.35580008, -0.89810023, -0.25850006,
    -0.29449069, -0.89797161, -0.32698964,
    -0.22000385, -0.89801571, -0.38100668,
    -0.13590467, -0.89803082, -0.41841435,
    -0.04600148, -0.89822890, -0.43711407,
    0.04600148, -0.89822890, -0.43711407,
    0.13589899, -0.89799323, -0.41849686,
    0.22000385, -0.89801571, -0.38100668,
    0.29420948, -0.89812898, -0.32681054,
    0.35580008, -0.89810023, -0.25850006,
    0.40179357, -0.89808560, -0.17889713,
    0.43019793, -0.89809568, -0.09139956,
    0.43979830, -0.89809657, 0.00000000,
    0.43019793, -0.89809568, 0.09139956,
    0.40179357, -0.89808560, 0.17889713,
    0.35580008, -0.89810023, 0.25850006,
    0.29429121, -0.89807319, 0.32689024,
    0.21989731, -0.89808903, 0.38089534,
    0.13590383, -0.89812531, 0.41821177,
    0.04599958, -0.89809176, 0.43739597,
    -0.04599958, -0.89809176, 0.43739597,
    -0.13590383, -0.89812531, 0.41821177,
    -0.21989731, -0.89808903, 0.38089534,
    -0.29429121, -0.89807319, 0.32689024,
    -0.35580008, -0.89810023, 0.25850006,
    -0.40179357, -0.89808560, 0.17889713,
    -0.22471200, -0.97325199, 0.04780255,
    -0.05999990, -0.99819838, 0.00000000,
    -0.05850061, -0.99821036, -0.01240013,
    -0.20969890, -0.97329487, -0.09339951,
    -0.18590659, -0.97323452, -0.13510480,
    -0.15370656, -0.97324157, -0.17080729,
    -0.11490453, -0.97323832, -0.19900783,
    -0.07100194, -0.97322667, -0.21860598,
    -0.02400098, -0.97333966, -0.22810930,
    0.02399879, -0.97325079, -0.22848844,
    0.07100194, -0.97322667, -0.21860598,
    0.11490453, -0.97323832, -0.19900783,
    0.15369423, -0.97326347, -0.17069359,
    0.18590659, -0.97323452, -0.13510480,
    0.20950964, -0.97334476, -0.09330429,
    0.22471200, -0.97325199, -0.04780255,
    0.22980847, -0.97323587, 0.00000000,
    0.22471200, -0.97325199, 0.04780255,
    0.20950964, -0.97334476, 0.09330429,
    0.18590659, -0.97323452, 0.13510480,
    0.15369423, -0.97326347, 0.17069359,
    0.11480380, -0.97333217, 0.19860657,
    0.07099814, -0.97327447, 0.21839428,
    0.02399934, -0.97327301, 0.22839368,
    -0.02399988, -0.97329524, 0.22829889,
    -0.07099969, -0.97329573, 0.21829904,
    -0.11480380, -0.97333217, 0.19860657,
    -0.15369160, -0.97324685, 0.17079067,
    -0.18590659, -0.97323452, 0.13510480,
    -0.20950767, -0.97333567, 0.09340342,
    -0.05850061, -0.99821036, 0.01240013,
    0.00000000, -1.00000000, 0.00000000,
    -0.05509891, -0.99818029, -0.02449951,
    -0.04859973, -0.99819437, -0.03529980,
    -0.04039896, -0.99817434, -0.04489885,
    -0.02990014, -0.99820456, -0.05190024,
    -0.01850026, -0.99821411, -0.05680080,
    -0.00630005, -0.99820839, -0.05950050,
    0.00630005, -0.99820839, -0.05950050,
    0.01850026, -0.99821411, -0.05680080,
    0.02999989, -0.99819639, -0.05199981,
    0.04019983, -0.99819579, -0.04459981,
    0.04850013, -0.99820273, -0.03520010,
    0.05509891, -0.99818029, -0.02449951,
    0.05850061, -0.99821036, -0.01240013,
    0.05999990, -0.99819838, 0.00000000,
    0.05850061, -0.99821036, 0.01240013,
    0.05509891, -0.99818029, 0.02449951,
    0.04850013, -0.99820273, 0.03520010,
    0.04009999, -0.99819980, 0.04459999,
    0.03000005, -0.99820157, 0.05190008,
    0.01859991, -0.99819520, 0.05709973,
    0.00630002, -0.99820245, 0.05960015,
    -0.00630005, -0.99820839, 0.05950050,
    -0.01850016, -0.99820844, 0.05690048,
    -0.03000005, -0.99820157, 0.05190008,
    -0.04019983, -0.99819579, 0.04459981,
    -0.04859973, -0.99819437, 0.03529980,
    -0.05509891, -0.99818029, 0.02449951,
  ]),
  materialIndex: 0,
};

const LAVA_MESH_1: RuneMesh = {
  name: "Lava_Rune_primitive1",
  positions: new Float32Array([
    0.53119999, 0.43310001, 0.34729996,
    0.38859999, 0.43309999, -0.08070003,
    0.26289999, 0.43309996, -0.23700003,
    0.16440000, 0.43309996, -0.43400002,
    0.01490000, 0.43309996, -0.57660007,
    -0.11760000, 0.43309996, -0.38640004,
    -0.11760000, 0.43309996, -0.38640004,
    -0.20590000, 0.43309999, -0.16900003,
    -0.39610001, 0.43309999, 0.02459997,
    -0.39950001, 0.43310001, 0.21819997,
    -0.49800000, 0.43310001, 0.44579998,
    -0.49800000, 0.43310001, 0.44579998,
    0.33419999, 0.43310001, 0.30649996,
    0.48120001, 0.41190004, 0.31239998,
    0.35229999, 0.41190001, -0.07450003,
    0.23870000, 0.41189998, -0.21570003,
    0.14970000, 0.41189998, -0.39370003,
    0.01460000, 0.41189998, -0.52270007,
    -0.10520000, 0.41189998, -0.35080004,
    -0.18500000, 0.41190001, -0.15430003,
    -0.35690001, 0.41190001, 0.02069997,
    -0.36000001, 0.41190001, 0.19569997,
    -0.44900000, 0.41190004, 0.40139997,
    -0.44900000, 0.41190004, 0.40139997,
    0.05360000, 0.41190004, 0.31729996,
    0.30320001, 0.41190004, 0.27549997,
    0.13030000, 0.36179999, -0.16920003,
    0.01960000, 0.36179996, -0.38930002,
    -0.03080000, 0.36179996, -0.24750003,
    -0.02600000, 0.36179999, -0.11060003,
    -0.02600000, 0.36179999, -0.11060003,
    -0.13169999, 0.36179999, -0.00020003,
    -0.29980001, 0.36180001, 0.25929996,
    0.24300000, 0.36179999, 0.05509998,
    0.01480000, 0.36179999, 0.16079997,
    0.01480000, 0.36179999, 0.16079997,
    0.34869999, 0.36180001, 0.21359996,
    0.20460001, 0.36179999, 0.16319998,
  ]),
  indices: new Uint16Array([
    1, 0, 13, 1, 13, 14, 2, 1, 14, 2, 14, 15,
    3, 2, 15, 3, 15, 16, 4, 3, 16, 4, 16, 17,
    5, 4, 17, 5, 17, 18, 7, 6, 18, 7, 18, 19,
    8, 7, 19, 8, 19, 20, 9, 8, 20, 9, 20, 21,
    11, 9, 21, 11, 21, 23, 25, 12, 10, 10, 23, 24,
    10, 24, 25, 0, 12, 25, 0, 25, 13, 26, 27, 16,
    26, 16, 15, 27, 18, 17, 27, 28, 19, 27, 19, 18,
    28, 30, 19, 29, 31, 19, 31, 32, 20, 32, 21, 20,
    20, 19, 31, 32, 22, 21, 27, 17, 16, 15, 14, 33,
    15, 33, 26, 24, 22, 32, 24, 32, 35, 36, 33, 14,
    36, 14, 13, 36, 13, 25, 24, 34, 37, 37, 36, 25,
    37, 25, 24,
  ]),
  normals: new Float32Array([
    -0.04190080, 0.99851900, -0.03470066,
    -0.86401498, -0.24360423, 0.44060764,
    -0.26049868, 0.95149515, 0.16369917,
    -0.75219161, -0.23479736, 0.61569309,
    0.07040256, -0.13430488, 0.98843598,
    0.82105237, -0.29258303, 0.49017158,
    0.82101978, -0.29260705, 0.49021182,
    0.31469052, 0.92677203, 0.20509381,
    0.92696761, -0.21829237, 0.30508932,
    0.31391144, 0.94423436, 0.09940362,
    0.76949298, -0.10719902, -0.62959425,
    0.76945219, -0.10720726, -0.62964270,
    0.04080035, 0.93370803, -0.35570303,
    -0.19340460, 0.94052244, -0.27930665,
    -0.36678181, 0.90445507, 0.21778919,
    -0.39480799, 0.88161783, 0.25860521,
    -0.39931644, 0.87943621, 0.25911066,
    0.07700027, 0.92930328, 0.36120128,
    0.49562042, 0.83503442, 0.23890985,
    0.39989215, 0.88158272, 0.25079508,
    0.40509328, 0.88318533, 0.23639608,
    0.54892724, 0.83224122, 0.07780386,
    0.26531312, 0.95364719, -0.14200702,
    0.26528781, 0.95365624, -0.14199349,
    -0.06710181, 0.91352462, -0.40121081,
    -0.03050105, 0.80022740, -0.59892052,
    -0.39729885, 0.89569736, 0.19969942,
    0.04459979, 0.96199542, 0.26939872,
    0.41430074, 0.90630162, 0.08350015,
    0.37501871, 0.91624569, 0.14090703,
    0.37498434, 0.91626175, 0.14089411,
    0.30739197, 0.91697604, 0.25429335,
    0.17590574, 0.97263170, -0.15180496,
    -0.34729162, 0.91527795, 0.20409508,
    -0.05989683, 0.91395157, -0.40137875,
    -0.05990230, 0.91393511, -0.40141540,
    -0.23379511, 0.96557982, -0.11399762,
    0.04839919, 0.96048386, -0.27409539,
  ]),
  materialIndex: 1,
};

const LAVA_MESH_2: RuneMesh = {
  name: "Lava_Rune_primitive2",
  positions: new Float32Array([
    0.13030000, 0.36179999, -0.16920003,
    0.01960000, 0.36179996, -0.38930002,
    0.30090001, 0.35080001, 0.17649996,
    0.20800000, 0.35080001, 0.14399996,
    0.20800000, 0.35080001, 0.14399996,
    0.20800000, 0.35080001, 0.14399996,
    0.01200000, 0.35080001, 0.14149997,
    0.01200000, 0.35080001, 0.14149997,
    -0.25479999, 0.35080004, 0.22499996,
    -0.11660000, 0.35080001, 0.01179997,
    -0.00650000, 0.35080001, -0.10320003,
    -0.01150000, 0.35079998, -0.24460003,
    0.02260000, 0.35079998, -0.34050003,
    0.11310000, 0.35080001, -0.16060004,
    0.11310000, 0.35080001, -0.16060004,
    0.22640000, 0.35080001, 0.06479997,
    0.22640000, 0.35080001, 0.06479997,
    -0.03080000, 0.36179996, -0.24750003,
    -0.02600000, 0.36179999, -0.11060003,
    -0.13169999, 0.36179999, -0.00020003,
    -0.29980001, 0.36180001, 0.25929996,
    0.24300000, 0.36179999, 0.05509998,
    0.01480000, 0.36179999, 0.16079997,
    0.01480000, 0.36179999, 0.16079997,
    0.34869999, 0.36180001, 0.21359996,
    0.20460001, 0.36179999, 0.16319998,
  ]),
  indices: new Uint16Array([
    25, 23, 6, 25, 6, 3, 15, 2, 4, 6, 8, 9,
    15, 4, 6, 12, 14, 15, 10, 11, 12, 6, 9, 10,
    12, 15, 6, 6, 10, 12, 22, 20, 8, 22, 8, 7,
    20, 19, 9, 20, 9, 8, 19, 18, 10, 19, 10, 9,
    18, 17, 11, 18, 11, 10, 17, 1, 12, 17, 12, 11,
    1, 0, 14, 1, 14, 12, 0, 21, 16, 0, 16, 13,
    21, 24, 2, 21, 2, 16, 24, 25, 5, 24, 5, 2,
  ]),
  normals: new Float32Array([
    -0.39729885, 0.89569736, 0.19969942,
    0.04459979, 0.96199542, 0.26939872,
    -0.12490322, 0.98742549, -0.09690250,
    0.16910563, -0.23270775, -0.95773190,
    0.16900849, -0.23271170, -0.95774809,
    0.16899231, -0.23268941, -0.95775635,
    -0.14079420, -0.23329040, -0.96216037,
    -0.14090576, -0.23330954, -0.96213940,
    0.13310429, 0.98593173, -0.10110326,
    0.21190262, 0.96281194, 0.16760208,
    0.91591967, -0.19820425, 0.34900750,
    0.27791259, 0.95964338, 0.04300195,
    0.01160044, 0.98213742, 0.18780715,
    -0.22930950, 0.96644007, 0.11580480,
    -0.22950960, 0.96644041, 0.11540483,
    -0.83739689, -0.24779907, 0.48719819,
    -0.83741765, -0.24770522, 0.48721023,
    0.41430074, 0.90630162, 0.08350015,
    0.37501871, 0.91624569, 0.14090703,
    0.30739197, 0.91697604, 0.25429335,
    0.17590574, 0.97263170, -0.15180496,
    -0.34729162, 0.91527795, 0.20409508,
    -0.05989683, 0.91395157, -0.40137875,
    -0.05990230, 0.91393511, -0.40141540,
    -0.23379511, 0.96557982, -0.11399762,
    0.04839919, 0.96048386, -0.27409539,
  ]),
  materialIndex: 2,
};

export const LAVA_MESHES: RuneMesh[] = [
  LAVA_MESH_0,
  LAVA_MESH_1,
  LAVA_MESH_2,
];
